import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Check, Phone, MessageCircle } from 'lucide-react';
import ThemeToggle from '../components/ThemeToggle';
import '../App.css';

function ThankYou() {
  const location = useLocation();
  const navigate = useNavigate();
  const { type, email, low, high, company } = location.state || {};

  useEffect(() => {
    document.title = 'Thank You | Orca Transports Ltd';
  }, []);

  return (
    <div className="page-wrapper">
      <nav className="navbar navbar-solid">
        <Link to="/" className="logo">ORCA TRANSPORTS</Link>
        <div className="nav-right">
          <Link to="/" className="back-link">← Back to site</Link>
          <ThemeToggle />
        </div>
      </nav>

      <section className="section thank-you-section">
        <div className="thank-you-icon"><Check size={32} strokeWidth={2.5} /></div>

        {type === 'quote' && low ? (
          <>
            <h1 className="legal-title">Your Quote Is Ready</h1>
            <div className="price-tag">
              <small>ESTIMATED TOTAL</small>
              <h1>£{low} - £{high}</h1>
              <p>+ VAT</p>
            </div>
            <p className="thank-you-sub">We've also emailed this quote to {email}.</p>
          </>
        ) : type === 'business' ? (
          <>
            <h1 className="legal-title">Request Received</h1>
            <p className="thank-you-sub">
              Thanks{company ? `, ${company}` : ''} — we'll contact you at {email} within 24 hours.
            </p>
          </>
        ) : (
          <>
            <h1 className="legal-title">Thanks!</h1>
            <p className="thank-you-sub">We've received your request and will be in touch shortly.</p>
          </>
        )}

        <div className="thank-you-actions">
          <a href="tel:+447501046288" className="cta-btn">
            <Phone size={16} strokeWidth={2} /> Call Us Now
          </a>
          <a
            href="https://wa.me/447501046288?text=Hi%2C%20I%27d%20like%20to%20follow%20up%20on%20my%20request%20from%20Orca%20Transports"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-btn cta-btn-whatsapp"
          >
            <MessageCircle size={16} strokeWidth={2} /> Chat on WhatsApp
          </a>
        </div>

        <button type="button" className="link-btn" onClick={() => navigate('/')}>← Back to home</button>
      </section>

      <footer>
        <h3>ORCA TRANSPORTS LTD</h3>
        <p>Victory House, Luton</p>
        <div className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span className="footer-dot">•</span>
          <Link to="/terms-of-service">Terms of Service</Link>
        </div>
        <p>© 2026 Orca Transports Ltd.</p>
      </footer>
    </div>
  );
}

export default ThankYou;
